function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import { scrollToAnchor } from "../../utils";
import { defaultNavList } from "../../utils/constants";
import { useToggleVisible } from "../../hooks/useToggleVisible";
var NavTab = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params;
  var _ref = props || {},
    title = _ref.title,
    _ref$navList = _ref.navList,
    navList = _ref$navList === void 0 ? defaultNavList : _ref$navList,
    containerBGColor = _ref.containerBGColor,
    fontColor = _ref.fontColor,
    fontSize = _ref.fontSize,
    tabBGColor = _ref.tabBGColor,
    activeFontColor = _ref.activeFontColor,
    activeFontSize = _ref.activeFontSize,
    activeTabBGColor = _ref.activeTabBGColor,
    backgroundImage = _ref.backgroundImage,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 30 : _ref$height;
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActivityTab = _useState2[1];
  var prefixCls = getPrefixCls('SmNavTab');
  var _useToggleVisible = useToggleVisible(),
    tabVisible = _useToggleVisible.visible,
    toggleVisible = _useToggleVisible.toggleVisible;
  useImperativeHandle(ref, function () {
    return {
      toggleVisible: toggleVisible
    };
  });
  var tabWidth = "".concat(Math.floor(100 / ((navList === null || navList === void 0 ? void 0 : navList.length) || 0)) - 3, "%");
  var activeStyle = {
    color: activeFontColor,
    fontSize: activeFontSize,
    backgroundColor: activeTabBGColor,
    borderColor: activeFontColor
  };
  var onTabClick = function onTabClick(index, target) {
    setActivityTab(index);
    if (isDev) return;
    scrollToAnchor(target);
  };
  if (!tabVisible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container"),
    id: title ? "me-".concat(title) : undefined,
    style: {
      backgroundColor: containerBGColor,
      backgroundImage: "url(".concat(backgroundImage, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }
  }, navList === null || navList === void 0 ? void 0 : navList.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "".concat(prefixCls, "-navItem"),
      style: _objectSpread({
        width: tabWidth,
        color: fontColor,
        borderColor: fontColor,
        fontSize: fontSize,
        backgroundColor: tabBGColor,
        height: "".concat(height, "px")
      }, activeTab === index ? activeStyle : {}),
      onClick: function onClick() {
        return onTabClick(index, item.target);
      }
    }, item === null || item === void 0 ? void 0 : item.title);
  }));
});
var EnhancedNavTab = EnhanceComponent(NavTab);
EnhancedNavTab.settings = setting;
export default EnhancedNavTab;